import { render, staticRenderFns } from "./TicketItem.vue?vue&type=template&id=04d7869d"
import script from "./TicketItem.vue?vue&type=script&lang=js"
export * from "./TicketItem.vue?vue&type=script&lang=js"
import style0 from "./TicketItem.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports